import { EyeOff, Layers, PanelBottom } from "lucide-react";

const MODES = [
  { value: "overlay", label: "On the image", icon: Layers },
  { value: "below", label: "Under the image", icon: PanelBottom },
  { value: "none", label: "Hide details", icon: EyeOff },
];

export const DisplayModePicker = ({ value, onChange }) => (
  <div className="grid grid-cols-3 gap-3" data-testid="event-display-mode-select" role="radiogroup">
    {MODES.map(({ value: v, label, icon: Icon }) => (
      <button
        key={v}
        type="button"
        role="radio"
        aria-checked={value === v}
        data-testid={`event-display-mode-${v}`}
        onClick={() => onChange(v)}
        className={`flex flex-col items-center gap-2 rounded-2xl border-2 px-2 py-4 text-xs font-bold transition-[background-color,border-color] duration-200 sm:text-sm ${
          value === v ? "border-blue-500 bg-blue-50 text-blue-700" : "border-slate-200 bg-white text-slate-600 hover:border-slate-300"
        }`}
      >
        <Icon className="h-5 w-5" />
        {label}
      </button>
    ))}
  </div>
);
